import { Component, Input } from '@angular/core';
import { IPos } from '@services/old-curriculum.service';

@Component({
    selector: 'curriculum-current',
    templateUrl: './current.component.html',
    styleUrls: ['./current.component.scss']
})
export class CurrentComponent {
    @Input() program: IPos;
    @Input() subject: string;

}
